//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginLayout from '../../layouts/LoginLayout';
import InputText from '../inputs/InputText';
import ApiHelper from '../../helpers/ApiHelper';
import { ArrowLeftIcon } from 'vue-feather-icons';

export default {
	name: 'LoginForm',
	components: { InputText, LoginLayout, ArrowLeftIcon },
	data() {
		return {
			apiHelper: new ApiHelper(),
			email: null,
			password: null,
		};
	},
	methods: {
		async login() {
			const user = {
				email: this.email,
				password: this.password,
			};
			await this.$auth
				.loginWith('local', {
					data: user,
				})
				.then((response) => {
					this.$router.push('/');
				})
				.catch((error) => {
					if (error.response.status === 401) {
						this.$store.commit('setAlert', {
							show: true,
							message: 'Sus credenciales no son correctas',
							type: 'danger',
						});
					} else if (error.response.status === 400) {
						this.$store.commit('setAlert', {
							show: true,
							message: 'Su cuenta no ha sido activada. Revise su correo electrónico.',
							type: 'danger',
						});
					} else {
						this.apiHelper.handleErrors(error, this.$refs.obs, this.$store);
					}
				});
		},
	},
};
